/**
 * This file was auto-generated.
 * Do not make direct changes to the file.
 */
/* eslint-disable @typescript-eslint/no-unused-vars */

import { z } from 'zod'
export const CustomerCardType = {
	Business: 'BUSINESS',
	Loyalty: 'LOYALTY'
} as const
export type CustomerCardTypeType = (typeof CustomerCardType)[keyof typeof CustomerCardType]
export type Customer = {
	uuid: string
	firstName?: string
	lastName?: string
	email?: string
	phone?: string
	ssn?: string
	createdAt: number
	updatedAt: number
	externalId?: string
	cards?: {
		uuid: string
		name: string
		cardNumber: string
		type: CustomerCardTypeType
		availablePoints?: number
	}[]
}
export type CustomerParams = {
	firstName?: string
	lastName?: string
	email?: string
	phone?: string
	ssn?: string
	externalId?: string
}

export const zCustomerCardType = z.enum(['BUSINESS', 'LOYALTY'])
export const zCustomer = z.object({
	uuid: z.string(),
	firstName: z.string().optional(),
	lastName: z.string().optional(),
	email: z.string().optional(),
	phone: z.string().optional(),
	ssn: z.string().optional(),
	createdAt: z.number(),
	updatedAt: z.number(),
	externalId: z.string().optional(),
	cards: z
		.array(
			z.object({
				uuid: z.string(),
				name: z.string(),
				cardNumber: z.string(),
				type: zCustomerCardType,
				availablePoints: z.number().optional()
			})
		)
		.optional()
})
export const zCustomerParams = z.object({
	firstName: z.string().optional(),
	lastName: z.string().optional(),
	email: z.string().optional(),
	phone: z.string().optional(),
	ssn: z.string().optional(),
	externalId: z.string().optional()
})
